import { trim } from "lodash";
import React, { useState } from "react";
import { Grid } from "@mui/material";

import Button from "../../../../components/Button-v2";
import { formatMonetary, formatPercentage } from "../../../../utils/formats";
import Input from "../ReadOnlyInput";
import { loadPoliticaCdcVeiculo } from "../../service";
import { toast } from "react-toastify";

const InformacoesCreditoSection = (props) => {
  const {
    proposalOperationLoading,
    valorGarantia,
    comprometimentoRenda,
    percentualGarantia,
    cpfCnpj,
    proposalNumber,
  } = props;

  const [politicaCdcVeiculoLoading, setPoliticaCdcVeiculoLoading] =
    useState(false);

  const goToUrl = (url) => {
    if (!url) return null;
    window.open(url, "_blank").focus();
  };

  const handlePoliticaCdcVeiculoLoaded = (politicaCdcVeiculo) => {
    if (trim(politicaCdcVeiculo?.url ?? "").length > 0) {
      goToUrl(politicaCdcVeiculo?.url);
    } else {
      toast.error("Endereço para o Motor de Crédito não encontrado");
    }
  };

  const handleClickMotorDeCredito = () => {
    const params = { proposalNumber, cpfCnpj };

    //Politica CDC Veículo (url motor de crédito)
    loadPoliticaCdcVeiculo(params, {
      setPoliticaCdcVeiculo: handlePoliticaCdcVeiculoLoaded,
      setPoliticaCdcVeiculoLoading,
    });
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={6} sm={4}>
          <Input
            loading={proposalOperationLoading}
            label="Valor garantia"
            value={
              formatMonetary(valorGarantia) +
              " (" +
              formatPercentage(percentualGarantia) +
              ")"
            }
          />
        </Grid>
        <Grid item xs={6} sm={4}>
          <Input
            loading={proposalOperationLoading}
            label="Comprometimento de renda"
            value={formatPercentage(comprometimentoRenda)}
          />
        </Grid>
        <Grid item xs={12} sm={4} lg={2} alignSelf="flex-end">
          <Button
            fontSize="12px"
            width="100%"
            height="32px"
            onClick={handleClickMotorDeCredito}
            loading={politicaCdcVeiculoLoading}
          >
            Motor de crédito
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default InformacoesCreditoSection;
